/** Legacy URL / path sentinels (UI Pattern A uses empty selection = all). */

export const MANAGEMENT_ALL_LOCATIONS_ID = "all";
export const MANAGEMENT_ALL_DEPARTMENTS_ID = "all";
